import { Trans } from '@lingui/react/macro';

import type { TVisitSummary } from '../../../../react-query/useVisitSummaries';

export const PerioPatientPill = ({
  visitSummary,
}: {
  visitSummary?: TVisitSummary;
}) => {
  if (!visitSummary?.isPerioPatient) return null;

  return (
    <div className="vai-bg-slate-200 vai-rounded-3xl vai-py-1 vai-px-2">
      <p className="vai-typography-small !vai-text-[12px] vai-whitespace-nowrap">
        <Trans>Perio Patient</Trans>
      </p>
    </div>
  );
};
